module.exports = __webpack_public_path__ + "Server-Unknown.AzureWebApp.517460f4d2d37bdc51f619c96c909ae0.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Unknown.AzureWebApp.png
// module id = 1267
// module chunks = 1